module.exports = __webpack_public_path__ + "img/dep_computerphoneandelectronics.60ed668d.png";